import { MabayaProductWithModelId } from '@/productDiscovery/SponsoredProducts/interfaces/MabayaProduct';

export const INIT_SPONSORED_DATA = 'product/INIT_SPONSORED_DATA';
export const FETCH_SPONSORED_DATA = 'product/FETCH_SPONSORED_DATA';
export const GET_SPONSORED_DATA_TOP_PRODUCT_SUCCESS =
  'product/GET_SPONSORED_DATA_TOP_PRODUCT_SUCCESS';
export const GET_SPONSORED_DATA_HIGHLIGHTED_PRODUCT_SUCCESS =
  'product/GET_SPONSORED_DATA_HIGHLIGHTED_PRODUCT_SUCCESS';
export const GET_SPONSORED_DATA_PLAYLIST_SUCCESS =
  'product/GET_SPONSORED_DATA_PLAYLIST_SUCCESS';
export const DISABLE_SPONSORED_PRODUCTS = 'product/DISABLE_SPONSORED_PRODUCTS';

export interface InitSponsoredData {
  type: typeof INIT_SPONSORED_DATA;
}

export interface FetchSponsoredData {
  type: typeof FETCH_SPONSORED_DATA;
  device: 'DESKTOP' | 'MOBILE';
}

export interface GetSponsoredDataTopProductSuccess {
  type: typeof GET_SPONSORED_DATA_TOP_PRODUCT_SUCCESS;
  topProducts: MabayaProductWithModelId[];
}

export interface GetSponsoredDataHighlightedProductSuccess {
  type: typeof GET_SPONSORED_DATA_HIGHLIGHTED_PRODUCT_SUCCESS;
  highlightedProducts: MabayaProductWithModelId[];
}

export interface GetSponsoredDataPlaylistSuccess {
  type: typeof GET_SPONSORED_DATA_PLAYLIST_SUCCESS;
  sponsoredPlaylist: MabayaProductWithModelId[];
}

export interface DisableSponsoredProducts {
  type: typeof DISABLE_SPONSORED_PRODUCTS;
}

export const fetchSponsoredData = (
  device: 'DESKTOP' | 'MOBILE',
): FetchSponsoredData => ({
  type: FETCH_SPONSORED_DATA,
  device,
});

export type SponsoredDataActions =
  | InitSponsoredData
  | GetSponsoredDataTopProductSuccess
  | GetSponsoredDataHighlightedProductSuccess
  | GetSponsoredDataPlaylistSuccess
  | DisableSponsoredProducts;
